<template>
  <odd-page title="Settings">
    <div>
      <d-card>
        <d-tabs card>
          <d-tab title="Storefront" active>
            <Hours v-if="!!settings.id" />
            <PaymentProcessor v-if="!!paymentProcessor" />
          </d-tab>
          <d-tab title="Website">
            <Frontend v-if="!!settings.id" :settings="settings" />
            <Shop v-if="!!settings.id" :settings="settings" />
          </d-tab>
          <d-tab title="Payment Processor">
            <d-row v-if="!!settings.id">
              <d-col cols="12">
                <d-button link @click="getStripeDashboardLink"
                  >Open Stripe Dashboard</d-button
                >
                <small v-if="!!stripeURL" class="d-block">
                  <a :href="stripeURL" class="btn btn-link btn-sm text-info">
                    (Click here if your browser blocks popups)
                  </a>
                </small>
              </d-col>
            </d-row>
          </d-tab>
        </d-tabs>
      </d-card>
    </div>
  </odd-page>
</template>

<script>
import Hours from "./Fields/Hours";
import PaymentProcessor from "./Fields/PaymentProcessor";

import Page from "@/components/layout/Page/Page.vue";

import Frontend from "./Groups/Frontend";
import Shop from "./Groups/Shop";

export default {
  data() {
    return {
      stripeURL: null
    };
  },
  components: {
    Hours,
    PaymentProcessor,
    Frontend,
    "odd-page": Page,
    Shop
  },
  created() {
    this.$store.dispatch("app/setTitles", { title: "Settings", subtitle: "" });
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    paymentProcessor() {
      return this.$store.state.settings.paymentProcessor;
    }
  },
  methods: {
    getStripeDashboardLink() {
      this.$store.dispatch("settings/getStripeDashboardLink").then(data => {
        window.open(data.url, "_blank");
        this.stripeURL = data.url;
      });
    }
  }
};
</script>

<style></style>
